import { Button } from '@/components/shared/buttons/button';
import { Text } from '@/components/shared/element/text';
import { Container } from '@/components/shared/layout/container';
import { Grid } from '@/components/shared/layout/grid';

interface MaintenanceListTableHeaderProps {
  title: string;
  isFullTable: boolean;
  toggleDataTrack: string;
  onToggleFullTableDisplay: () => void;
}

const TABLE_DISPLAY_FULL_TITLE = 'ดูแบบเต็ม';
const TABLE_DISPLAY_BRIEF_TITLE = 'ดูแบบย่อ';
const TABLE_DISPLAY_FULL_ICON = 'grid-view';
const TABLE_DISPLAY_BRIEF_ICON = 'list';

export const MaintenanceListTableHeader = (
  props: MaintenanceListTableHeaderProps
) => {
  return (
    <Container data-test="maintenance_tableTop">
      <Grid
        alignItems="center"
        justifyContent="between"
        columnGap="6"
        css={{ gridTemplateColumns: 'auto max-content' }}
      >
        <Text
          as="h2"
          size={{
            '@initial': 'text-body-1',
            '@md': 'text-sub-h2',
            '@xl': 'text-sub-h1',
          }}
          font="bold"
          data-test="maintenance_engineTitle"
          css={{ mb: -2 }}
        >
          {props.title}
        </Text>
        <Button
          label={
            props.isFullTable
              ? TABLE_DISPLAY_BRIEF_TITLE
              : TABLE_DISPLAY_FULL_TITLE
          }
          icon={
            props.isFullTable
              ? TABLE_DISPLAY_BRIEF_ICON
              : TABLE_DISPLAY_FULL_ICON
          }
          border
          variant="button-gray"
          size="md"
          onClick={props.onToggleFullTableDisplay}
          test={{
            dataTest: props.isFullTable
              ? 'shortTable_button'
              : 'fullTable_button',
          }}
          tracking={{
            dataTrack: props.toggleDataTrack,
            dataTrackText: props.isFullTable
              ? TABLE_DISPLAY_FULL_TITLE
              : TABLE_DISPLAY_BRIEF_TITLE,
            dataTrackValue: props.title,
          }}
        />
      </Grid>
    </Container>
  );
};

MaintenanceListTableHeader.displayName = 'SectionMaintenanceListTableHeader';
